
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconArrowLeft = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M22.548 10.561H5.437a.251.251 0 01-.165-.438l8.637-7.6a1.44 1.44 0 00-1.9-2.162L.828 10.2a2.4 2.4 0 000 3.6l11.179 9.837a1.44 1.44 0 001.9-2.161l-8.637-7.6a.251.251 0 01.165-.438h17.113a1.44 1.44 0 000-2.879z' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12.743 23.5a.499.499 0 01-.33-.124L.769 13.125a1.472 1.472 0 01-.499-1.027A.423.423 0 01.257 12c0-.026.003-.048.007-.066v-.03c.025-.399.204-.765.505-1.03L12.412.625a.5.5 0 11.661.75L1.571 11.5h21.671a.5.5 0 010 1H1.574l11.5 10.125a.501.501 0 01-.331.875z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M11.25 23.25a.743.743 0 01-.53-.22L.22 12.53a.74.74 0 01-.163-.245l-.01-.026a.75.75 0 01.009-.541.74.74 0 01.166-.249L10.72.97a.744.744 0 011.06 0c.142.141.22.33.22.53s-.078.389-.22.53l-9.22 9.22h20.69a.75.75 0 010 1.5H2.561l9.22 9.22a.75.75 0 01-.531 1.28z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconArrowLeft.displayName = 'IconArrowLeft';
export default IconArrowLeft;